<template>
  <div class="container">
    <breadcrumbs></breadcrumbs>

    <h1 class="title is-4">Projectenlijst</h1>

    <div class="field">
      <div class="label is-small">Zoeken:</div>
      <input
        class="input is-small"
        type="text"
        v-model="searchTerm"
        placeholder="Typ hier uw zoekopdracht om te zoeken op naam of plaats van het project..."
      />
    </div>
    <div class="columns is-multiline">
      <div class="column is-half" v-for="project in filteredProjects" :key="project.projectId">
        <div class="card pointer" @click="selectProject(project)">
          <div class="card-content">
            <div class="parent">
              <div class="label">naam:</div>
              <div class="projectname">{{ project.name }}</div>
              <div class="projectname" style="float:right;" v-if="isAdmin">#{{ project.projectId }}</div>
            </div>

            <div class="parent">
              <div class="label">adres:</div>
              <div class="text">{{ project.address }}</div>
            </div>

            <div class="parent">
              <div class="label">plaats:</div>
              <div class="text">{{ project.city }}</div>
            </div>
            <div class="parent">
              <div class="label">postcode:</div>
              <div class="text">{{ project.zipCode }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-half" v-if="isAdmin">
        <div class="card pointer">
          <div class="card-content">
            <div class="columns is-mobile is-centered">
              <a class="button is-medium is-centered" @click="isIntroProjectModalActive = true">
                <span class="icon is-large">
                  <i class="far fa-plus-square fa-2x"></i>
                </span>
              </a>
              <b-modal :active.sync="isIntroProjectModalActive" has-modal-card>
                <intro-project-modal
                  @next="
                    isIntroProjectModalActive = false
                    isCreateProjectModalActive = true
                  "
                ></intro-project-modal>
              </b-modal>
              <b-modal :active.sync="isCreateProjectModalActive" has-modal-card :canCancel="[]">
                <create-project-modal
                  @close="isCreateProjectModalActive = false"
                  @succeed="succeedded"
                ></create-project-modal>
              </b-modal>
              <b-modal :active.sync="isInitProjectModalActive" has-modal-card :canCancel="[]">
                <building-modal
                  :projectData="dataModal"
                  :createProjectBool="createProject"
                  @close="isInitProjectModalActive = false"
                ></building-modal>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/General/Breadcrumbs'
import ProjectService from '@/services/projectService'
import CreateProjectModal from '@/components/Projects/CreateProjectModal.vue'
import BuildingModal from '@/components/Projects/BuildingModal.vue'
import IntroProjectModal from '@/components/Projects/IntroProjectModal.vue'

export default {
  components: {
    Breadcrumbs,
    CreateProjectModal,
    BuildingModal,
    IntroProjectModal
  },

  data() {
    return {
      projects: [],
      isCreateProjectModalActive: false,
      isInitProjectModalActive: false,
      isIntroProjectModalActive: false,
      dataModal: [],
      createProject: true,
      searchTerm: ''
    }
  },

  computed: {
    isAdmin() {
      // TODO: check in store for user access level
      return this.$store.getters.adminClaim || this.$store.getters.dataAdminClaim
    },
    filteredProjects: function() {
      if (this.searchTerm == '' || !this.searchTerm || !this.projects) {
        return this.projects
      }
      const st = this.searchTerm.toLowerCase()
      return this.projects.filter(a => a.name.toLowerCase().includes(st) || a.city.toLowerCase().includes(st))

      return this.projects
      // return this.projects.filter(p => {
      //   return this.$store.state.auth.projectClaims.has(p.projectId)
      // })
    }
  },

  async mounted() {
    await this.$store.dispatch('getBearerToken')
    await this.$store.dispatch('getProjectList')
    this.projects = this.$store.getters.projectList
  },

  methods: {
    succeedded(payload) {
      this.dataModal = payload
      this.isCreateProjectModalActive = false
      this.isInitProjectModalActive = true
    },
    projectCreated() {
      this.isCreateProjectModalActive = false
      this.isInitProjectModalActive = true
      // ask for new token to update claims
    },
    selectProject(project) {
      this.$store.dispatch('setProject', project)
      this.$router.push('/projectoverview/' + project.projectId)
    }
  }
}
</script>

<style lang="css" scoped>
ul {
  list-style: none;
  padding-left: 0px;
}
.parent {
  /* display: inline; */
  white-space: nowrap;
}
.parent div {
  display: inline-block;
}
.label {
  font-size: 0.75rem;
  color: #666;
  min-width: 50px;
}
.text {
  font-size: 1rem;
}
.projectname {
  color: red;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/ProjectList.vue